<app-spinner></app-spinner>

<div class="container" style="max-width: 75% !important;" id="contact" *ngIf="!this.apierror">

  <div>
    <h1 class="text-center">Kategorie {{ this.getOperation() }}</h1>
  </div>

  <div class="form">
    <!--TODO Form Validation-->
    <form role="form" class="php-email-form" [formGroup]="userform" (ngSubmit)="this.onSubmit()">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="displayname" class="form-label">
            Anzeigename
          </label>
          <input type="text" name="displayname" class="form-control" id="displayname"
                 placeholder="Anzeigename*" formControlName="displayname" required
                 [class.is-invalid]="(this.getFormControls()['displayname'].touched || this.getFormControls()['displayname'].dirty) && this.getFormControls()['displayname'].invalid">
          <div *ngIf="this.getFormControls()['displayname'].touched && this.getFormControls()['displayname'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['displayname'].errors?.['required']">Der Titel ist erforderlich.</div>
            <div *ngIf="this.getFormControls()['displayname'].errors?.['pattern']">Der Titel enthält ein ungültiges
              Zeichen.
            </div>
            <div *ngIf="this.getFormControls()['displayname'].errors?.['minlength']">Der eingegebene Titel ist zu kurz
            </div>
          </div>
        </div>

        <div class="form-group col-md-6">
          <label for="filtername" class="form-label">
            Filtername
          </label>
          <input type="text" name="filtername" class="form-control" id="filtername"
                 placeholder="Filtername*" formControlName="filtername" required
                 [class.is-invalid]="(this.getFormControls()['filtername'].touched || this.getFormControls()['filtername'].dirty) && this.getFormControls()['filtername'].invalid">
          <div *ngIf="this.getFormControls()['filtername'].touched && this.getFormControls()['displayname'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['filtername'].errors?.['required']">Der Titel ist erforderlich.</div>
            <div *ngIf="this.getFormControls()['filtername'].errors?.['pattern']">Der Titel enthält ein ungültiges
              Zeichen.
            </div>
            <div *ngIf="this.getFormControls()['filtername'].errors?.['minlength']">Der eingegebene Titel ist zu kurz
            </div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="category" class="form-label">
            Kategorie
          </label>
          <select class="form-control" name="category" id="category"
                  formControlName="category" required title="category"
                  [class.is-invalid]="(this.getFormControls()['category'].touched || this.getFormControls()['category'].dirty) && this.getFormControls()['category'].invalid">
            <option value="" selected disabled hidden="hidden">Kategorie wählen</option>
            <option value='industry'>Branche</option>
            <option value='contract_type'>Vertragsart</option>
            <option value='timemodel'>Zeitmodel</option>
            <option value='remote'>Remote</option>
          </select>
          <div
            *ngIf="(this.getFormControls()['category'].touched || this.getFormControls()['category'].dirty) && this.getFormControls()['category'].invalid"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['category'].errors?.['required']">Die Kategorie ist erforderlich</div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="active" class="form-label">
            Aktiv
          </label>
          <select class="form-control" name="active" id="active"
                  formControlName="active" required
                  [class.is-invalid]="(this.getFormControls()['active'].touched || this.getFormControls()['active'].dirty) && this.getFormControls()['active'].invalid">
            <option value="" selected disabled hidden="hidden">Aktiv ?</option>
            <option value="true">Ja</option>
            <option value="false">Nein</option>
          </select>
        </div>

        <div class="pb-3">
          <div *ngIf="this.sentstatus === 1" class="sent-message">Der Filter wurde
            erfolgreich {{ this.operation === "edit" ? "Editiert" : "Erstellt" }}
          </div>
          <div *ngIf="this.sentstatus === 2" class="error-message">Der Filter konnte leider nicht
            erfolgreich {{ this.operation === "edit" ? "Editiert" : "Erstellt" }} werden
          </div>
          <div *ngIf="this.sentstatus === 3" class="error-message">Sie haben zu viele Anfragen gestellt, bitte versuchen
            Sie es später nochmal
          </div>
        </div>
        <div class="text-center">
          <button *ngIf="this.operation === 'edit' || this.operation === 'create'" type="submit"
                  class="btn btn-success mb-3">Speichern
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
